import type { App } from 'vue';
import Vue from 'vue';
import { I18n, I18nOptions, createI18n } from 'vue-i18n';
import { CookieStorage } from '@do/do-auth-web-client';
import en from './lang/en/en.json';
import zh from './lang/zh-CN/zh.json';

export let i18n: any;

async function createI18nOptions(): Promise<I18nOptions> {
  const hasChinese = (str: string) => {
    return /[\u4e00-\u9fa5]/.test(str);
  };
  const cookieStorage = new CookieStorage();
  const locale = cookieStorage.getLocaleInfo() || 'zh';
  return {
    legacy: false,
    locale,
    fallbackLocale: locale,
    silentTranslationWarn: true, // true - warning off
    missingWarn: true,
    silentFallbackWarn: true,
    messages: {
      en,
      zh,
    },
    missing: (locale, key, vm) => {
      console.warn(`Missing translation key: ${key}`);
      if (hasChinese(key)) {
        // return `MISSING: ${key}`;
        return key;
      }
      return key;
    },
  };
}

// setup i18n instance with glob
export async function setupI18n(app: App) {
  const options = await createI18nOptions();
  i18n = createI18n(options) as I18n;
  app.use(i18n);
}
